import { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Divider,
  Modal,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import WorkIcon from "@mui/icons-material/Work";

const useStyles = makeStyles((theme) => ({
  careerCardContent: {
    maxWidth: "500px",
  },
  careerCardContentShift: {
    justifyContent: "center",
    position: "relative",
    paddingTop: "15px",
    boxxShadow: "0px 8px 18px -1px rgb(0 0 0 / 20%) !important",
    transition: "0.25s",
    borderRadius: "15px",
  },
  careerCardContentJob: {
    position: "static",
    width: "300px",
    cursor: "default",
    transition: "all 0.2s ease-out",
    margin: "10px",
    "&:hover": {},
  },
  careerTitleStyle: {
    fontSize: 19,
    letterSpacing: 0.15,
    fontFamily: "Poppins",
    fontWeight: "bold",
    color: "rgba(0, 27, 17, 1)",
    textAlign: "center",
    marginBottom: 5,
    marginTop: 4,
  },
  cardTitleStyle: {
    backgroundColor: "#2eb790",
    width: "100%",
    padding: "3px",
    borderRadius: "5px",
  },
  singleCard: {
    color: "white",
    fontSize: 18,
    letterSpacing: 0.15,
    fontFamily: "Poppins",
    fontWeight: "500",
    textAlign: "center",
  },
  careerRoleStyle: {
    fontSize: 13,
    letterSpacing: 0.15,
    fontFamily: "Open sans",
    fontWeight: 600,
    color: "rgba(0, 27, 17, 0.7)",
    lineHeight: 1.6,
    display: "inline",
  },
  careerRoleStyleText: {
    fontSize: 13,
    letterSpacing: 0.15,
    fontFamily: "Open sans",
    fontWeight: 600,
    color: "rgba(0, 27, 17, 0.7)",
    lineHeight: 1.6,
  },
  careerRoleStyleText2: {
    fontSize: 13,
    letterSpacing: 0.15,
    fontFamily: "Open sans",
    fontWeight: 600,
    color: "rgba(0, 27, 17, 0.7)",
    lineHeight: 1.6,
    paddingLeft: "100px",
    paddingBottom: "20px",
  },
  careerRole2Style: {
    fontSize: 13,
    letterSpacing: 0.15,
    fontFamily: "Open sans",
    fontWeight: 600,
    color: "rgba(0, 27, 17, 0.7)",
    justifyContent: "flex-start",
    paddingLeft: 20,
  },
  marginCustom: {
    marginTop: 1,
    marginBottom: 1,
  },
  marginCustomButton: {
    display: "flex",
    justifyContent: "center",
  },
  buttonProperties: {
    width: 190,
    height: 27,
    borderRadius: 24,
    background: "#2eb790",
    fontSize: 13,
    marginTop: 5,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    position: "absolute",
    fontWeight: "bold",
    fontSize: "13px",
    lineHeight: "1.6",
  },
  titleQual: {
    border: "1px solid red",
  },
  "@media screen and (max-width: 400px)": {
    careerRoleStyleText: {
      paddingLeft: "0px",
      Top: "10px.",
    },
    title: {
      position: "relative",
      bottomTop: "10px",
    },
    careerCardContentJob: {
      width: "250px",
    },
    careerCardContent: {
      maxHeight: "500px",
      overflow: "auto",
    },
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    maxWidth: "80%",
    marginTop: theme.spacing(1),
    borderRadius: 25,
    padding: "5px 10px 5px 10px",
  },
  modalCard: {
    paddingBottom: theme.spacing(4),
    borderRadius: 25,
  },
  cancelButton: {
    minWidth: "unset !important",
    padding: "0 !important",
    fontSize: 30,
    borderRadius: 0,
    marginTop: "0 !important",
  },
}));

const CareerCard = ({ cardProps }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <article className="cardWrapperJob" role="article">
        <Card
          className={classes.careerCardContentShift}
          role="region"
          aria-labelledby="career-card-title"
        >
          <CardContent className={classes.careerCardContentJob}>
            <Grid
              container
              direction="column"
              justifyContent="space-evenly"
              alignItems="stretch"
            >
              <Grid item>
                <header>
                  <Typography
                    className={classes.careerTitleStyle}
                    id="career-card-title"
                  >
                    {cardProps.title} <WorkIcon className="workIconCareer" />
                  </Typography>
                </header>
              </Grid>
              <Divider variant="middle" />

              <Grid item className={classes.marginCustom}>
                <section>
                  <dl>
                    <Typography component="div">
                      <dt className="boldCareerCard">Location: </dt>
                      <dd className={classes.careerRoleStyle}>
                        {cardProps.location}
                      </dd>
                    </Typography>
                  </dl>
                </section>
              </Grid>
              <Grid item className={classes.marginCustom}>
                <section>
                  <dl>
                    <Typography component="div">
                      <dt className="boldCareerCard"> Type: </dt>
                      <dd className={classes.careerRoleStyle}>
                        {cardProps.type}
                      </dd>
                    </Typography>
                  </dl>
                </section>
              </Grid>
              <Grid item className={classes.marginCustomButton}>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.buttonProperties}
                  onClick={handleOpen}
                  sx={{ textTransform: "none", letterSpacing: "1px" }}
                  aria-label="View Post"
                >
                  View Post
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </article>

      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        role="dialog"
        aria-aria-labelledby="career-modal-title"
      >
        <div className="container--modal_wrapper-CareerCard">
          <div className={classes.paper}>
            <div className="careerCard">
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item>
                  <Button
                    disableRipple={true}
                    variant="text"
                    className="button--modal_cancelJob"
                    aria-label="Close modal"
                    onClick={handleClose}
                  >
                    <CloseRoundedIcon fontSize="inherit" />
                  </Button>
                </Grid>
              </Grid>
              <Card className={classes.modalCard} role="document">
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  className={classes.cancelButton}
                >
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    <Grid item></Grid>
                  </Grid>
                </Grid>
                <CardContent className={classes.careerCardContent}>
                  <Grid
                    container
                    direction="column"
                    justifyContent="space-evenly"
                    alignItems="stretch"
                    gap={1}
                  >
                    <Grid item className={classes.cardTitleStyle}>
                      <header>
                        <Typography
                          className={clsx(
                            classes.careerTitleStyle && classes.singleCard
                          )}
                          aria-label="Career Card Title"
                        >
                          {cardProps.title}
                        </Typography>
                      </header>
                    </Grid>

                    <Grid item className={classes.marginCustom}>
                      <section>
                        <dl>
                          <Grid container direction="row">
                            <Grid item xxs={5} xs={3.5} sm={3} md={2.5}>
                              <Typography component="div">
                                <dt className="boldCareerCard">Location: </dt>
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xxs={7}
                              xs={8.5}
                              sm={9}
                              md={9.5}
                              className={classes.careerRoleStyle}
                              aria-label="Location"
                            >
                              <dd>{cardProps.location}</dd>
                            </Grid>
                          </Grid>
                        </dl>
                      </section>
                    </Grid>

                    <Grid
                      item
                      className={classes.marginCustom}
                      sx={{ height: "20px" }}
                    >
                      <section>
                        <dl>
                          <Grid container direction="row">
                            <Grid item xxs={5} xs={3.5} sm={3} md={2.5}>
                              <dt className="boldCareerCard">Type:</dt>
                            </Grid>
                            <Grid
                              item
                              xxs={7}
                              xs={8.5}
                              sm={9}
                              md={9.5}
                              className={classes.careerRoleStyle}
                              aria-label="Type"
                            >
                              <dd>{cardProps.type}</dd>
                            </Grid>
                          </Grid>
                        </dl>
                      </section>
                    </Grid>

                    <Grid item className={classes.marginCustom}>
                      <section>
                        <dl>
                          <Grid container direction="row">
                            <Grid
                              item
                              xxs={5}
                              xs={3.5}
                              sm={3}
                              md={2.5}
                              aria-label="Description"
                            >
                              <dt className={classes.title}>Description:</dt>
                            </Grid>
                            <Grid
                              item
                              xxs={7}
                              xs={8.5}
                              sm={9}
                              md={9.5}
                              className={classes.careerRoleStyleText}
                            >
                              <dd>{cardProps.description}</dd>
                            </Grid>
                          </Grid>
                        </dl>
                      </section>
                    </Grid>

                    <Grid item className={classes.marginCustom}>
                      <section>
                        <dl>
                          <Grid container direction="row">
                            <Grid
                              item
                              xxs={5}
                              xs={3.5}
                              sm={3}
                              md={2.5}
                              aria-label="Qualifications"
                            >
                              <dt className={classes.title}>Qualifications:</dt>
                            </Grid>
                            <Grid
                              item
                              xxs={7}
                              xs={8.5}
                              sm={9}
                              md={9.5}
                              className={classes.careerRoleStyleText}
                            >
                              <dd>{cardProps.qualifications}</dd>
                            </Grid>
                          </Grid>
                        </dl>
                      </section>
                    </Grid>
                    <Grid
                      item
                      className={classes.marginCustom}
                      style={{ alignSelf: "center" }}
                    >
                      <section>
                        <div className="paddingText">
                          <Button
                            color="primary"
                            variant="contained"
                            className={classes.buttonProperties}
                            href={cardProps.link}
                            target="_blank"
                            rel="noreferrer noopener"
                            aria-label="Apply on LinkedIn"
                          >
                            Apply on LinkedIn
                          </Button>
                        </div>
                      </section>
                    </Grid>
                  </Grid>
                </CardContent>
                <Typography align="center">
                  Or email your resume to
                  <a
                    className="emailLinkCareer"
                    href="mailto: hr@teammateme.org"
                    aria-label="Email HR"
                  >
                    {" "}
                    hr@teammateme.org
                  </a>
                </Typography>
              </Card>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CareerCard;
